import { createSelector } from '@ngrx/store';

import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { rolesAdapter } from './roles.reducer';

export const getRolesState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.roles
);

export const {
  selectIds: getRolesIds,
  selectEntities: getRolesEntities,
  selectAll: getRolesAll,
  selectTotal: getRolesTotal
} = rolesAdapter.getSelectors(getRolesState);
